import { CogOutlineIcon } from './CogOutlineIcon';

/**
 * author: Google
 * id D29B92ED-BC81-44F0-8031-2E48A90ABAD8
 * name cog-outline
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-outline.svg
 * tags
 * - Settings 
 */
export const SettingsOutlineIcon = CogOutlineIcon;
export default SettingsOutlineIcon